module.exports = __webpack_public_path__ + "media/images/topics/topics-heading-bg-ind-f474ff406e159f663fd21b2e20477f10.png";